var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { numberWithSuffix } from "@domains/utils/numberMethods";
import EdModal from "@frameworks/shared-library/components/edModal";
var ESIPFrequency;
(function (ESIPFrequency) {
    ESIPFrequency["MONTHLY"] = "monthly";
    ESIPFrequency["QUARTERLY"] = "quarterly";
    ESIPFrequency["HALF_YEARLY"] = "half yearly";
    ESIPFrequency["ANNUALLY"] = "annually";
    ESIPFrequency["YEARLY"] = "yearly";
    ESIPFrequency["DAILY"] = "daily";
    ESIPFrequency["FORTNIGHTLY"] = "fortnightly";
})(ESIPFrequency || (ESIPFrequency = {}));
var nextInstallmentDescription = {
    monthly: "Future installments start at least 30 days after your first installment, as per BSE guidelines.",
    quarterly: " Your SIP will be deducted once every three months on the selected date.",
    "half yearly": "Your SIP will be deducted every six months on the selected date.",
    annually: "Your SIP will be deducted once a year on the selected date.",
    yearly: "- Your SIP will be deducted once a year on the selected date.",
    daily: "Your SIP will be deducted every day on the selected date.",
    fortnightly: "Your SIP will be deducted once every two weeks on the selected date.",
};
var SipCalendar = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = __read(useState(false), 2), open = _f[0], setOpen = _f[1];
    var _g = __read(useState(), 2), selectedVal = _g[0], setSelectedVal = _g[1];
    var inputRef = useRef(null); //type
    var calendarRef = useRef(null);
    var handleClickOutside = function (event) {
        var _a, _b;
        var target = event.target;
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) &&
            !((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
            (calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current) &&
            !((_b = calendarRef.current) === null || _b === void 0 ? void 0 : _b.contains(target))) {
            setOpen(false);
            props.setIsCalendarOpen && (props === null || props === void 0 ? void 0 : props.setIsCalendarOpen(false));
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(function () {
        var _a;
        setSelectedVal((_a = props.dateList) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.value === props.selectedVal; }));
    }, [props.selectedVal, props.dateList]);
    return (React.createElement("div", { className: "sip-calendar mgt-5" },
        React.createElement(InputField
        // placeholder="Select installment date"
        , { 
            // placeholder="Select installment date"
            inputRef: inputRef, className: "d-flex flex-row align-items-center sip-calendar-input", placeholderClassName: "txt-whispering-periwinkle DMSansNormal_12_400", onFocus: function () {
                setOpen(true);
                props.setIsCalendarOpen && (props === null || props === void 0 ? void 0 : props.setIsCalendarOpen(true));
            }, value: "".concat(numberWithSuffix(Number((_b = (_a = props.dateList) === null || _a === void 0 ? void 0 : _a.find(function (z) { return z.value == props.selectedVal; })) === null || _b === void 0 ? void 0 : _b.label.toString())), " ").concat((_c = props === null || props === void 0 ? void 0 : props.suffixTextforSelectedValue) !== null && _c !== void 0 ? _c : ""), prefix: React.createElement("i", { className: "edel-icon-calendar-rounded txt-whispering-periwinkle" }), readOnly: true }),
        React.createElement(EdModal, { show: open, setShow: setOpen, closeDropdown: setOpen, modalTitle: "sip-calendar-modal", showFooter: false, closeOnOutsideClick: true, children: React.createElement("div", { ref: calendarRef, className: "position-absolute w-100 d-flex flex-column align-items-start sip-calendar-dropdown" },
                React.createElement("label", { className: "DMSans_13_400" },
                    "Select ",
                    props.transactionType ? props.transactionType : "SIP",
                    " ",
                    "Installment Date"),
                React.createElement("div", { className: "d-grid static-calendar" }, ((_d = props.dateList) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                    props.dateList.map(function (x, i) {
                        return (React.createElement(EdButton, { key: i, btnTyp: "text-only", value: x.label.toString(), className: "Roboto_12_400 ".concat((selectedVal === null || selectedVal === void 0 ? void 0 : selectedVal.value) === (x === null || x === void 0 ? void 0 : x.value) ? "active" : ""), type: "button", onClick: function () {
                                setSelectedVal(x);
                            }, disabled: (x === null || x === void 0 ? void 0 : x.value) === "" }));
                    })),
                React.createElement("div", { className: "w-100" },
                    React.createElement("div", { className: "installment-block my-4 p-10 bg-sea-shell" },
                        React.createElement("label", { className: "txt_blackOne1 DMSans_13_400" },
                            "Next Installment -",
                            React.createElement("span", { className: "Roboto_13_400" }, selectedVal === null || selectedVal === void 0 ? void 0 : selectedVal.value)),
                        (props === null || props === void 0 ? void 0 : props.isPayNow) && (props === null || props === void 0 ? void 0 : props.selectedFrequency) && (React.createElement("div", { className: "DMSansNormal_12_400 txt-gray-error guideline-block" }, nextInstallmentDescription[(_e = props === null || props === void 0 ? void 0 : props.selectedFrequency) === null || _e === void 0 ? void 0 : _e.toLowerCase()] || ""))),
                    React.createElement("div", { className: "d-flex justify-content-between" },
                        React.createElement(EdButton, { btnTyp: "text-only", value: "Back", type: "button", className: "txt-han-blue DMSanN_14_400 d-flex w-50 justify-content-center align-items-center", onClick: function () {
                                var _a;
                                setOpen(false);
                                props.setIsCalendarOpen && (props === null || props === void 0 ? void 0 : props.setIsCalendarOpen(false));
                                if (props.selectedVal !== selectedVal.value) {
                                    setSelectedVal((_a = props.dateList) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.value === props.selectedVal; }));
                                }
                            } }),
                        React.createElement(EdButton, { btnTyp: "dark-peach-rounded", value: "Confirm", type: "button", className: "py-2 confirm-btn", onClick: function () {
                                props.setSelectedVal(selectedVal);
                                setOpen(false);
                                props.setIsCalendarOpen && (props === null || props === void 0 ? void 0 : props.setIsCalendarOpen(false));
                            } })))) })));
};
export default SipCalendar;
